// extracted by mini-css-extract-plugin
module.exports = {"cancelBtn":"CommonModalV2_cancelBtn__25G8D","saveBtn":"CommonModalV2_saveBtn__deDl2"};